import {Component, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {Router} from '@angular/router';
import {PageQuery, Proposal, ProposalService, SearchItem} from '@tatynanny/api';
import {merge} from 'rxjs';
import {startWith, switchMap} from 'rxjs/operators';


@Component({
  selector: 'app-devis',
  templateUrl: './devis.page.html',
  styleUrls: ['./devis.page.scss'],
})
export class DevisPage implements OnInit {

  segment: 'SENT' | 'ACTIVE' | 'ALL' = 'ALL';
  data: Proposal[] = [];
  displayedColumns: string[] = ["proposalId", "creationDate", "requestForEstimateLink.pricing.productType", "proposalStatus", "requestForEstimateLink.totalPriceTTC", "action"];
  service: string = "";
  inputId: string = "";
  selectedDate: string = "";

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  pageQuery: PageQuery = {
    fields: [
      {field: "proposalId", value: this.inputId},
      {field: "requestForEstimateLink.pricing.productType", value: this.service},
      {field: "proposalStatus", value: this.segment},
      {field: "creationDate", value: this.selectedDate}
    ],
    sort: 'creationDate',
    direction: 'desc',
  }

  searchItems: SearchItem[] = [];

  constructor(
    private proposalService: ProposalService,
    private router: Router,
  ) { }

  ngOnInit(): void {

  }

  refresh(): void {
    this.searchItems = [
      {field: "proposalId", value: this.inputId},
      {field: "requestForEstimateLink.pricing.productType", value: this.service},
      {field: "proposalStatus", value: this.segment},
      {field: "creationDate", value: this.selectedDate}
    ];
    this.pageQuery.fields = this.searchItems;
    this.proposalService.search(this.pageQuery).subscribe((res: any) => {
      console.log('[devis] (search)', res);
      this.data = res.content;
    })
  }


  ngAfterViewInit() {
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.pageQuery.sort = this.sort.active;
      this.pageQuery.direction = this.sort.direction;
      console.log(this.sort.active);
    });
    this.pageQuery.page = this.paginator.pageIndex;
    this.pageQuery.pageSize = this.paginator.pageSize;

    merge(this.sort.sortChange, this.paginator.page).pipe(startWith({}), switchMap(() => {
      return this.proposalService.search(this.pageQuery);
    })).subscribe((data: any) => {
      console.log('[devis] (search)', data);
      (this.data = data.content)
    });
  }

  onSegmentChange(event: any): void {
    console.log(event);
    this.segment = event;
    this.refresh();

  }

  onInputChange(event: any): void {
    console.log('[devis] (onInputChange)', event);
    this.inputId = event;
    this.refresh();
  }

  onServiceChange(event: any): void {
    console.log('[devis] (onServiceChange)', event);
    this.service = event.value;
    this.refresh();
  }

  onDateChange(event: any): void {
    console.log('[devis] (onDateChange)', event);
    this.selectedDate = event;
    this.refresh();
  }

  openProposal(proposal: Proposal): void {
    console.log('[devis] (openProposal)', proposal);
    this.router.navigateByUrl(`/mon-espace/devis/detail/${proposal.id}`);
  }


}
